"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _classnames = _interopRequireDefault(require("classnames"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _PollEditor = _interopRequireDefault(require("./PollEditor"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Poll = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Poll, _Component);

  var _super = _createSuper(Poll);

  function Poll() {
    var _this;

    (0, _classCallCheck2.default)(this, Poll);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedAnswer: null,
      isEditing: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSubmit", function (event) {
      event.preventDefault();
      var selectedAnswer = _this.state.selectedAnswer;
      if (!selectedAnswer) return;

      _this.props.handlePollSelection(selectedAnswer);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSelection", function (option) {
      if (!(0, _insidedDataStorage.getInsidedData)('user').userid) {
        var event = new window.CustomEvent('GuestUserAction');
        window.dispatchEvent(event);
        return;
      }

      _this.setState({
        selectedAnswer: option
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Poll, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var isEditing = this.state.isEditing;
      var _this$props = this.props,
          poll = _this$props.poll,
          answeredPoll = _this$props.answeredPoll,
          votes = _this$props.pollVotes,
          _this$props$displayEx = _this$props.displayExtendedActions,
          displayExtendedActions = _this$props$displayEx === void 0 ? false : _this$props$displayEx,
          _onShowAlert = _this$props.onShowAlert,
          _onPollUpdate = _this$props.onPollUpdate,
          topicId = _this$props.topicId,
          contentType = _this$props.contentType,
          _this$props$isPreview = _this$props.isPreview,
          isPreview = _this$props$isPreview === void 0 ? false : _this$props$isPreview;
      var pollVotesMapping = {};
      var totalAnswerCount = Object.keys(votes).length;
      Object.keys(votes).forEach(function (vote) {
        var option = votes[vote];
        pollVotesMapping[option] = pollVotesMapping[option] ? pollVotesMapping[option] + 1 : 1;
      });
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('poll', 'qa-poll', 'topic-poll-wrapper')
      }, (0, _preact.h)("h4", {
        className: "h5 qa-poll-question"
      }, poll.title), answeredPoll ? (0, _preact.h)("ul", {
        className: (0, _classnames.default)('list', 'list--stacked', 'poll__results', 'qa-list-poll-results')
      }, poll.options.map(function (option) {
        var _pollVotesMapping$opt;

        var optionVoteCount = (_pollVotesMapping$opt = pollVotesMapping[option]) !== null && _pollVotesMapping$opt !== void 0 ? _pollVotesMapping$opt : 0;
        var optionVotePercentage = Math.round(optionVoteCount / totalAnswerCount * 100);
        return (0, _preact.h)("li", {
          key: option,
          className: "list__item"
        }, (0, _preact.h)("div", {
          className: "poll__result-group"
        }, (0, _preact.h)("div", {
          className: "poll__result-indicator qa-poll-result-indicator",
          style: {
            width: "".concat(optionVotePercentage, "%")
          }
        })), (0, _preact.h)("span", {
          className: "poll__result-option qa-poll-result-option"
        }, option), (0, _preact.h)("span", {
          className: "poll__result-votes qa-poll-result-votes"
        }, (0, _preact.h)("span", null, optionVoteCount === 0 ? '0 ' : '', (0, _preact.h)(_phrase.default, {
          p: "{n} Vote|{n} Votes",
          count: {
            n: optionVoteCount
          }
        }))), totalAnswerCount > 0 ? (0, _preact.h)("span", {
          className: "poll__result-percentage qa-poll-result-percentage"
        }, " (".concat(optionVotePercentage, "%)")) : null);
      })) : (0, _preact.h)("form", {
        onSubmit: this.handleSubmit,
        className: "form js-poll-form",
        method: "post"
      }, poll.options.map(function (option, index) {
        return (0, _preact.h)("div", {
          className: "form__row",
          key: index
        }, (0, _preact.h)("div", {
          className: "choices fancyselect"
        }, (0, _preact.h)("input", {
          type: "radio",
          name: "vote",
          className: "qa-answer--".concat(index),
          onClick: function onClick() {
            return _this2.handleSelection(option);
          },
          id: "vote-".concat(index),
          value: index,
          required: true,
          disabled: isPreview
        }), (0, _preact.h)("label", {
          htmlFor: "vote-".concat(index),
          className: "qa-poll-option-label"
        }, option)));
      }), (0, _preact.h)("div", {
        className: "form__row"
      }, (0, _preact.h)("button", {
        type: "submit",
        id: "pollSubmit",
        className: (0, _classnames.default)('btn--toggle', 'qa-button-poll-submit', {
          'is-loading': this.props.pollSelectionLoading
        }),
        disabled: isPreview || this.state.selectedAnswer === null
      }, (0, _preact.h)(_phrase.default, {
        p: "vote!"
      }), (0, _preact.h)("span", {
        className: "loader"
      })))), displayExtendedActions && (isEditing ? (0, _preact.h)(_PollEditor.default, {
        onShowAlert: function onShowAlert(type, message) {
          return _onShowAlert === null || _onShowAlert === void 0 ? void 0 : _onShowAlert(type, message);
        },
        poll: poll,
        onPollUpdate: function onPollUpdate(data) {
          return _onPollUpdate === null || _onPollUpdate === void 0 ? void 0 : _onPollUpdate(data);
        },
        contentType: contentType !== null && contentType !== void 0 ? contentType : 'article',
        topicId: topicId !== null && topicId !== void 0 ? topicId : 0,
        onTogglePollEditor: function onTogglePollEditor() {
          return _this2.setState({
            isEditing: false
          });
        }
      }) : (0, _preact.h)(_Button.default, {
        variant: "secondary",
        onClick: function onClick() {
          return _this2.setState({
            isEditing: true
          });
        },
        "data-qa": "topic-poll__edit-button"
      }, "Edit poll")));
    }
  }]);
  return Poll;
}(_preact.Component);

var _default = Poll;
exports.default = _default;